import { render, staticRenderFns } from "./ResetPasswordFormComponent.vue?vue&type=template&id=4ccb420c&scoped=true&"
import script from "./ResetPasswordFormComponent.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordFormComponent.vue?vue&type=style&index=0&id=4ccb420c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccb420c",
  null
  
)

export default component.exports